import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../../../shared/services/language.service';
import { FetchBuyerInfoDetailsService } from '../../services/fetch-buyer-info-details.service';

@Component({
  selector: 'app-buyer-info-details',
  templateUrl: './buyer-info-details.component.html',
  styleUrls: ['./buyer-info-details.component.scss']
})
export class BuyerInfoDetailsComponent implements OnInit {
  info: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private detailService: FetchBuyerInfoDetailsService,
    private router: Router,
    public translate: TranslateService,
    private languageService: LanguageService
  ) { }

  async ngOnInit() {
    this.translate.use(localStorage.getItem("language"));
    this.languageService.languageUpdated.subscribe((lang: string) => {
      this.translate.use(lang);
    });
    if (!this.activatedRoute.snapshot.params.id) {
      this.router.navigate(['/']);
    } else {
      const id = this.activatedRoute.snapshot.params.id;
      this.detailService.setParams({ id });
      const result = await this.detailService.make();
      this.info = result;
      console.log(result);
    }
  }
}
